import * as React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';
import Label from './Label.jsx';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';

export default function RadioInput(props) {
	const { slug, label, options, selected, autoTrad } = props;

	const handleChange = (e) => {
		props.parentFunction(e.target.value, slug);
	};

	return (
		<ThemeProvider theme={backYouTheme}>
			<FormControl className='h-100 mt-1'>
				<Label label={label}/>
				<RadioGroup 
					row
					value={selected}
					onChange={(e) => handleChange(e)}
				>
					{options.map((e, i) => 
						<FormControlLabel
							sx={{ marginRight: '12px' }}
							key={e.slug}
							value={e.slug}
							control={<Radio sx={{ padding: '3px' }} />}
							label={autoTrad ? (e.label).trad() : e.label}
						/>
					)}
				</RadioGroup>
			</FormControl>
		</ThemeProvider>
	);
}